import { DisplayNames, DeviceMeta } from 'Roblox';
import React, { useState, useEffect } from 'react';
import EachGamelistContainer from '../../gameLists/containers/EachGameListContainer';
import gamesService from '../../gameData/services/gamesService';
import gamesApiConstants from '../../gameData/constants/gamesApiConstants';
import { getFriendsPresence } from '../../../../ts/react/common/services/bedev1Services';
import presenceTypes from '../../userData/constants/presenceTypes';
import placeListsLayout from '../../gameLists/constants/placeListsLayout';

function PlacelistContainer(props) {
  const [sortsData, setSortsData] = useState([]);
  const [timeFiltersData, setTimeFiltersData] = useState([]);
  const [pageContext, setPageContext] = useState({});
  const [friendsData, setFriendsData] = useState([]);

  useEffect(() => {
    gamesService.getGamesSorts(gamesApiConstants.gamesHomeSortAlgorithm, true).then(
      result => {
        setPageContext(result?.pageContext);
        setTimeFiltersData(result?.timeFilters);
        if (result?.sorts) {
          setSortsData(result.sorts);
        }
      },
      error => {
        console.debug(error);
      }
    );
    return () => {};
  }, []);

  const handleFriendsPresenceData = friendsPresenceData => {
    const userIdsInUniverses = {};
    friendsPresenceData.forEach(friendPresence => {
      const currentFriendPresence = friendPresence;
      if (currentFriendPresence?.presence?.userPresenceType === presenceTypes.ingame.status) {
        const { universeId, userId } = currentFriendPresence?.presence;
        if (!userIdsInUniverses[universeId]) {
          userIdsInUniverses[universeId] = [];
        }
        userIdsInUniverses[universeId].push(userId);
      }
      const { displayName, name } = currentFriendPresence;
      currentFriendPresence.nameForDisplay = DisplayNames.Enabled() ? displayName : name;
    });
    setFriendsData(friendsPresenceData);
  };

  useEffect(() => {
    let unsubscribeUserData = () => {};
    const deviceType = DeviceMeta() ? DeviceMeta().deviceType : '';
    if (deviceType.toLowerCase() === placeListsLayout.deviceTypes.computer.toLowerCase()) {
      unsubscribeUserData = getFriendsPresence().then(
        result => {
          if (result?.userData) {
            handleFriendsPresenceData(result.userData);
          }
        },
        error => {
          console.debug(error);
        }
      );
    }
    return () => {
      unsubscribeUserData();
    };
  }, []);

  return (
    <React.Fragment>
      {sortsData.length > 0 &&
        sortsData.map((sort, index) => {
          return (
            <EachGamelistContainer
              sortPosition={index}
              sort={sort}
              pageContext={pageContext}
              timeFilters={timeFiltersData}
              key={sort.token + sort.displayName}
              friendsData={friendsData}
              pageType={placeListsLayout.pageTypes.home}
              {...props}
            />
          );
        })}
    </React.Fragment>
  );
}

export default PlacelistContainer;
